import { commonConfigurations } from './environment.commonConfigurations';
import { EnvironmentSpecificServiceList, IEnvironment, IEnvironmentSpecificConfigurations } from './environment.model';

const environmentSpecificServiceList = new EnvironmentSpecificServiceList('stg');

const initialNavigation: any = 'disabled';
export const environmentSpecificConfigurations: IEnvironmentSpecificConfigurations = {
    BuildVersion: 'v1.526.0',
    IsAzStorage: true,
    production: true,
    IsStaging: true,
    beeUid: 'stage',
    isSSo: false,
    initialNavigation,
    action: `https://`,
    SubDomainName: `ipex-audit-center.selisestage.com`,
    DomainName: `selisestage.com`,
    SessionKey: `set_from_stage-ipex-audit-center.selisestage.com`,
    landingUri: `https://ipex-audit-center.selisestage.com`,
    SiteId: 'CF55B6DF-585D-4AEF-8A71-43C11E8ACEA8',
    BuildPipelineId: 'baad454e-7566-43e7-a124-1aa290e770ad',
    MaintenanceManagerURL: `https://stg-maintenancemanager.selise.biz/api/tenants`,
    JarowaWorkorderUrl: `https://www-appenzell-pool.enable.jarowa.ch/workOrderDetail/WORKORDER_ID/00000000-0000-0000-0000-000000000000`,
    WagePredictionService: `https://ipex-wage-prediction.stage.ipex.ch`,
    WagePredictionServiceUserName: `selise`,
    WagePredictionServicePassword: `ibexDerSteinbock#008`,
    caseCenterUri: 'https://upload-ipex.selisestage.com',
    SlackWebHookUrl: 'https://hooks.slack.com/services/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',
    SlackAdminWebHookUrl: 'https://hooks.slack.com/services/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',
    ClaimCenterUri: "https://selise-repair-center.stage.ipex.ch",
    IpexFileService: 'https://ipex-file-service.stage.ipex.ch',
    IpexDataBeastService: 'https://ipex-data-beast.stage.ipex.ch',
    ClaimCenterLinkBaseUri: "https://selise-repair-center.stage.ipex.ch",
    UILMUrl: 'https://api.seliseblocks.com/uilm/v1/Key/GetUilmFile',
    ProjectKey: '0642F0100AA14E3BBD2B1037A9363E07',
    AutoClearingUserId: '8fb2b75b-38cb-4c50-869e-ca76a2e4a8b0'
};

export const environment: IEnvironment = {
    ...commonConfigurations,
    ...environmentSpecificConfigurations,
    ...environmentSpecificServiceList
};

export const environmentStage = environment;
